module.exports = __webpack_public_path__ + "img/service5.dc99ab26.jpg";